import { gql } from '@apollo/client';

const CREATE_JOIN_MUTATION = gql`
mutation CreateContact($contact: PartnerContactInput!) {
    createContact(contact: $contact) {
        type,
        lpsContact {
            joinId,
            propertyId,
            userId
        },
        rejectedReason
    }
}`;

const FETCH_SUBMARKET_ID = gql`
query FetchSubmarketId($address:PropertyAddress!, $lypsIntegration: Boolean) {
    fetchSubmarketId(address: $address, lypsIntegration: $lypsIntegration)
}`;

const FETCH_SALESFORCE_INFORMATION = gql`
query FetchSalesforceInformation($request: SalesforceInformationInput!) {
    fetchSalesforceInformation(contact: $request) {
        isSelfServe,
        submarketId,
        reason
    }
}`;
export {
    CREATE_JOIN_MUTATION,
    FETCH_SUBMARKET_ID,
    FETCH_SALESFORCE_INFORMATION
};
